(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_image-text-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('image-text-media')) {
    class ImageTextMedia extends HTMLElement {
      connectedCallback() {
        this.#video = this.querySelector('video');
        this.#button = this.querySelector('[data-image-text-playback]');

        if (!this.#video || !this.#button) return;

        this.#playIcon = this.#button.querySelector('[data-image-text-play]');
        this.#pauseIcon = this.#button.querySelector('[data-image-text-pause]');
        this.#reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.#button.addEventListener('click', this.#onToggle);
        this.#reducedMotion.addEventListener('change', this.#onReducedMotion);
        this.#video.removeAttribute('controls');
        this.#video.controls = false;
        this.classList.add('is-ready');
        this.#setPlaying(!this.#reducedMotion.matches);
      }

      disconnectedCallback() {
        if (this.#button) this.#button.removeEventListener('click', this.#onToggle);
        if (this.#reducedMotion) this.#reducedMotion.removeEventListener('change', this.#onReducedMotion);
        if (this.#video) this.#video.pause();
      }

      #video = null;
      #button = null;
      #playIcon = null;
      #pauseIcon = null;
      #reducedMotion = null;

      #onToggle = () => {
        if (!this.#video) return;

        this.#setPlaying(this.#video.paused);
      };

      #onReducedMotion = () => {
        if (this.#reducedMotion?.matches) this.#setPlaying(false);
      };

      #setPlaying(playing) {
        if (!this.#video || !this.#button) return;

        if (playing) {
          this.#video.play().catch(() => {
            this.#showState(false);
          });
        } else {
          this.#video.pause();
        }

        this.#showState(playing);
      }

      #showState(playing) {
        if (!this.#button) return;

        if (this.#playIcon) this.#playIcon.hidden = playing;
        if (this.#pauseIcon) this.#pauseIcon.hidden = !playing;

        const label = playing ? this.#button.dataset.pauseLabel : this.#button.dataset.playLabel;

        if (label) this.#button.setAttribute('aria-label', label);
      }
    }

    customElements.define('image-text-media', ImageTextMedia);
  }
  } catch(e) { console.error(e); }
})();

})();
